export const TrailerState = {
  ALL: 'All',
  ARRIVED: 'Arrived',
  DEPARTED: 'Departed',
} as const;

export type TrailerState = (typeof TrailerState)[keyof typeof TrailerState];
